module.exports = __webpack_public_path__ + "e48fb5c4ea29ad3765f510e87b24448d.pdf";